import React from "react";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import {moreCardsText, navButtons} from "../../constants/copyright";
import classNames from "classnames";
import {usePanel} from "../../redux/reducer/panel";
import {CSSTransition} from "react-transition-group";
import styles from "./MoreCards.module.scss";

const MoreCards = React.forwardRef(
  function MoreCards({onClick, className, isShow, button, visibleMore = true, noneContent = true}, ref) {
    const {padding} = usePanel()

    const {buttonToTop} = navButtons;
    return (
      <section className={classNames(styles.moreCards, className, {
        [styles.moreCards_show]: isShow
      })} ref={ref}>
        <div className={styles.moreCards__content}>
          <CSSTransition in={visibleMore && noneContent} unmountOnExit mountOnEnter timeout={400} classNames={{
            enter: styles.moreCards__btnWrapperNodeEnter,
            enterActive: styles.moreCards__btnWrapperEnterActive,
            enterDone: styles.moreCards__btnWrapperEnterDone,
            exit: styles.moreCards__btnWrapperExit,
            exitActive: styles.moreCards__btnWrapperExitActive
          }}>
            <div className={styles.moreCards__btnWrapper}>
              <Button
                className={classNames(

                  buttonStyles.button_black,
                  buttonStyles.button_big,
                  {
                    [buttonStyles['button_padding']]: padding
                  },
                  styles.moreCards__button,
                )}
                onClick={onClick}
                text={moreCardsText}
              >
                {padding && <div className={'button__preloader'}></div>}
                <div className="button__effect"/>
              </Button>
            </div>
          </CSSTransition>
          {noneContent && <Button {...buttonToTop}
                                  className={classNames(styles.moreCards__buttonTop, buttonToTop.className )}
                                  onClick={() => scrollTo({top: 0, behavior: "smooth"})}
          />}
        </div>
      </section>
    );
  });
export default MoreCards;
MoreCards.propTypes = {};

